// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>13</span>&nbsp;&nbsp;The hidden purpose of the Lord is for those who fear him&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and he will show them his covenant.<br> </p> </div></div>";
// Exports
module.exports = code;